import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { IconButton } from "@material-ui/core";

import { Icon } from "../../components";
import { getWebBridge } from "../../utils/webBridge";
import { firebaseEvent, screenType } from "../../utils/firebaseEvent";
interface Props {
  onClick?: () => void;
  onBackCallback?: () => void;
}

const HeaderBackButton = ({ onClick, onBackCallback }: Props) => {
  const history = useHistory();

  const jsonParams = {
    P1: screenType(),
    P2: window.location.pathname,
  };
  const onClickBackButton = () => {
    if (onClick) {
      onClick();
      return;
    }

    try {
      const { isFirst } = window.history.state;
      if (isFirst) history.replace(`/feeds`);
      else onBack();
    } catch {
      onBack();
    }
  };

  //Firebase Event

  const onBack = () => {
    firebaseEvent("click_back", jsonParams);
    if (onBackCallback) onBackCallback();
    history.goBack();
  };

  useEffect(() => {
    getWebBridge({ name: "onBackPress", callBack: onClickBackButton });
    // eslint-disable-next-line
  }, [onClick]);

  return (
    <IconButton onClick={onClickBackButton} style={{ marginRight: "auto" }}>
      <Icon name="arrowBack" size={28} />
    </IconButton>
  );
};

export default HeaderBackButton;
